$(document).ready(function() { 

  $(document).on('click','.filter-select-label',function(e) {
    e.stopPropagation();
    var $this = $(this).parent('.filter-select-box');
    $this.toggleClass('opened').parents().find('.filter-select-box').not($this).removeClass('opened');
  });
  
  $(document).on('click', function() {
    $('.filter-select-box').removeClass('opened');
  });
  
  $(document).on('click', '.sorting-item', function () {
    if (!$(this).hasClass('active')) {
      var windowURL = window.location.origin + window.location.pathname;
      var sortURL = $(this).data('value');

      var URL = `${windowURL}?sort_by=${sortURL}`;
      filterSort(URL);
    }
  });

  $(document).on('click', '.filter-title', function() {
    $(this).toggleClass('active');
    $(this).next('.filter-list').slideToggle();
  });

  $(document).on('click', '.filter-toggle', function() {
    $('body').addClass('filter-opened');
  });

  $(document).on('click', '.filter-close, .filter-mask', function() {
    $('body').removeClass('filter-opened');
  });

  $(document).on('click', '.filter-item', function () {
    $(this).toggleClass('active').siblings('.filter-item').removeClass('active');

    if ($(window).width() > 1199) {
      filter();
    }
  });

  $(document).on('click', '.pagination a', function (e) {
    var $wrap = $('#collection-list-wrap');
    if (!$wrap.length || !$('#collection-list').length) {
      return; // no AJAX collection containers on this page - let the browser navigate normally
    }
    e.preventDefault();
    var URL = window.location.origin + $(this).attr('href');
    var top = $wrap.offset().top;

    history.pushState({ page: URL }, null, URL);
    $('.collection-loader').addClass('showed');

    // keep the current products on screen (emptying the grid collapses the page
    // and dumps the viewport onto the footer) and glide up while the next page loads
    var scrollDone = $.Deferred();
    if (Math.abs(window.scrollY - top) < 5) {
      scrollDone.resolve();
    } else {
      var settle = function () {
        window.removeEventListener('scrollend', settle);
        scrollDone.resolve();
      };
      window.addEventListener('scrollend', settle);
      setTimeout(settle, 900); // browsers without the scrollend event
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // swap the products only after both the fetch and the scroll are finished,
    // so the animation is never cancelled by a layout change
    $.when($.ajax({ url: URL }), scrollDone).done(function (ajaxArgs) {
      $('.collection-loader').removeClass('showed');
      var collectionMain = $(ajaxArgs[0]).find('#collection-list').html();
      if (!collectionMain) {
        window.location.href = URL; // fetched page has no AJAX container - load it normally
        return;
      }
      $('#collection-list').html(collectionMain);
      if (window.scrollY > top + 5) {
        window.scrollTo({ top: top, behavior: 'instant' }); // scroll was interrupted - finish the trip
      }
    }).fail(function () {
      window.location.href = URL; // request failed - fall back to a full page load
    });
  });

  $(document).on('click', '.filter-view-result', function () {
    filter();
    $('body').removeClass('filter-opened');
  });
  
  $(document).on('click', '.product-view-item', function () {
    if (!$(this).hasClass('active')) {
      var value = $(this).data('value');
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          'attributes[pagination]': value
        },
        success: function(d){
          var URL = window.location.href;
          filterSort(URL);
        },
        dataType: 'json'
      });
    }
  });
  
  $(document).on('click', '.layout-toggle', function () {
    if ($(this).data('value') == 'list') {
      $('.product-grid .grid__item').addClass('product-layout-list');
    } else {
      $('.product-grid .grid__item').removeClass('product-layout-list');
    }
    if (!$(this).hasClass('active')) {
      $(this).addClass('active').siblings('.layout-toggle').removeClass('active');
      
      var value = $(this).data('value');
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          'attributes[grid_layout]': value
        },
        dataType: 'json'
      });
    }
  });
});

function filter() {
  var windowURL = window.location.origin;
  var collectionURL = 'collections/' + window.location.pathname.split('/')[2];

  var tags = [];

  $('.filter-item').each(function() {
    if ($(this).hasClass('active')) {
      var value = $(this).data('value');
      tags.push(value);
    }
  });
  
  if (tags.length) {
    var URL = `${windowURL}/${collectionURL}/${tags.join('+')}`;
  } else {
    var URL = `${windowURL}/${collectionURL}`;
  }
  
  history.pushState({
    page: URL
  }, null, URL);
  
  $('#collection-list .collection-grid').html('');
  $('.collection-loader').addClass('showed');

  $.ajax({
    url: URL,
    success: function (data) {
      $('.collection-loader').removeClass('showed');

      var collectionMain = $(data).find('#collection-list').html();
      $('#collection-list').html(collectionMain);

      function isEmpty(el) {
        return !$.trim($('#collection-list .product-grid').html());
      }

      if (isEmpty($('#element'))) {
        $('#collection-list .product-grid').html('<p class="empty-text">There no products in the collection</p>');
      }
    }
  });
}

function filterSort(URL, onLoaded) {
  history.pushState({
    page: URL
  }, null, URL);

  $('#collection-list .collection-grid').html('');
  $('.collection-loader').addClass('showed');

  $.ajax({
    url: URL,
    success: function (data) {
      $('.collection-loader').removeClass('showed');

      var collectionMain = $(data).find('#collection-list').html();
      if (!collectionMain) {
        window.location.href = URL; // fetched page has no AJAX container - load it normally
        return;
      }
      $('#collection-list').html(collectionMain);
      if (onLoaded) {
        onLoaded();
      }
    },
    error: function () {
      window.location.href = URL; // request failed - fall back to a full page load
    }
  });
}